import { IInitialValues } from './type';

export const INITIAL_VALUES: IInitialValues = {
  old_password: '',
  password: '',
  password_again: '',
};
